import { coreApi } from "./coreApi";

export const subscriptionsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSubscriptions: builder.query({
      query: () => ({
        url: "/administrator/subscriptions",
        method: "GET",
      }),
    }),
    createSubscription: builder.mutation({
      query: (subscription) => ({
        url: "/administrator/subscriptions/store",
        method: "POST",
        body: subscription,
      }),
    }),
    getSpecificSubscription: builder.query({
      query: (subscriptionId) => ({
        url: `/administrator/subscriptions/${subscriptionId}`,
        method: "GET",
      }),
    }),
    updateSubscription: builder.mutation({
      query: (subscriptionId, subscription) => ({
        url: `/administrator/subscriptions/update/${subscriptionId}`,
        method: "POST",
        body: subscription,
      }),
    }),
    deleteSubscription: builder.mutation({
      query: (subscriptionId) => ({
        url: `/administrator/subscriptions/delete/${subscriptionId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllSubscriptionsQuery,
  useCreateSubscriptionMutation,
  useGetSpecificSubscriptionQuery,
  useUpdateSubscriptionMutation,
  useDeleteSubscriptionMutation,
} = subscriptionsApi;
